import {
  setMergedColRowSpanKey,
  transformMergeCellsToRowColSpanResult,
  calculateEqualMergeCells
} from '../config/merge-cell'
import { getValue } from '../../utils/tools'

export default {
  data() {
    return {
      states: {
        fixedRowsMergedCellsMap: {}
      }
    }
  },
  methods: {
    // 获取合并行列的key值。
    getFixedRowsColRowSpanResult(rowIndex, columnIndex) {
      const key = setMergedColRowSpanKey(rowIndex, columnIndex)
      return this.states.fixedRowsMergedCellsMap[key]
    },
    // 存储合并行列的结果集。以 rowIndex、columnIndex为维度
    setFixedRowsMergedColRowSpanResult({ rowIndex, columnIndex, colRowSpan }) {
      const key = setMergedColRowSpanKey(rowIndex, columnIndex)
      this.states.fixedRowsMergedCellsMap[key] = colRowSpan
    },
    /**
     *
     * @description 把单元格的值，按列或者行以数组的方式记录下来对应的位置信息
     * @param {*} cellValue
     * @param {*} { key, column, rowIndex, columnIndex }
     * @description 实际结构如下 以row行来存储时，则key为每一行的索引值rowIndex，value则为列的索引值columnIndex
     *      下面表示在表格中 以行（row）来看，第一行的第一列，第二行的第一列，第三行的3、4、5列的单元格值为 ‘cs’
     *      以列（col）来看，第一列的1、2行，第3列的第二行，第4列的第二行，第5列的第二行的单元格的值为‘cs’
     *      {
     *        'cs': {
     *                  row: {0: [0], 1: [0], 2: [2,3,4]},
     *                  col: {0: [0, 1], 2: [2], 3: [2], 4: [2]},
     *                  key: 'xxx',
     *                  column
     *              }
     *      }
     */
    setfixedRowsMergedCellsMap(cellValue, { key, column, rowIndex, columnIndex }) {
      if (!this.states.fixedRowsMergedCellsMap[cellValue]) {
        this.states.fixedRowsMergedCellsMap[cellValue] = {
          row: {},
          col: {},
          key,
          column
        }
      }
      const iter = (direction, isRow) => {
        const index = isRow ? rowIndex : columnIndex
        const value = isRow ? columnIndex : rowIndex
        if (!this.states.fixedRowsMergedCellsMap[cellValue][direction][index]) {
          this.states.fixedRowsMergedCellsMap[cellValue][direction][index] = []
        }
        this.states.fixedRowsMergedCellsMap[cellValue][direction][index].push(value)
      }
      // 行记录列
      iter('row', true)
      // 列记录行
      iter('col', false)
    },
    clearfixedRowsMergedCellsMap() {
      this.states.fixedRowsMergedCellsMap = {}
    },
    /**
     *
     * @description 收集相同的单元格值的单元格信息，此时仅收集。
     * @param {*} rowData
     * @param {*} rowIndex
     * @param {*} tableData
     */
    getfixedRowsMergedCellsMap(fixedRows) {
      const mergeFixedRowsEqualCellsOption = this.table.$props.mergeFixedRowsEqualCellsOption
      if (!mergeFixedRowsEqualCellsOption || !Array.isArray(fixedRows)) {
        return
      }
      for (let rowIndex = 0; rowIndex < fixedRows.length; rowIndex++) {
        const rowData = fixedRows[rowIndex]
        const { beforeMergeValue, beforeMergeKey = [] } = mergeFixedRowsEqualCellsOption
        const columns = this.states.mainColumns.filter(i => !(i.children && i.children.length))
        if (columns) {
          for (let i = 0; i < columns.length; i++) {
            const column = columns[i]
            const { key, originIndex: columnIndex } = column
            // 使用原始的索引值去做合并列的计算。否则导致位置偏移
            if (['_index'].includes(key)) {
              continue
            }
            let mergeKey =
              typeof beforeMergeKey === 'function' && beforeMergeKey({ column, rowData, columnIndex, rowIndex })
            let cellValue = getValue(mergeKey || key, rowData)
            if (beforeMergeValue && typeof beforeMergeValue === 'function') {
              cellValue = beforeMergeValue({ column, rowData, value: cellValue, rowIndex, columnIndex })
            }
            // undefined null NaN不做处理
            if (cellValue === undefined || cellValue === null) {
              continue
            }
            this.setfixedRowsMergedCellsMap(cellValue, {
              key,
              column,
              // tableData,
              rowIndex,
              columnIndex
            })
          }
        }
      }
      this.transformFixedRowsToRowColSpanResult()
    },
    transformFixedRowsToRowColSpanResult() {
      const fixedRowsMergedCellsMap = this.states.fixedRowsMergedCellsMap
      const mergeFixedRowsEqualCellsOption = this.table.$props.mergeFixedRowsEqualCellsOption
      if (!Object.keys(fixedRowsMergedCellsMap).length) {
        return
      }
      const mergeCells = calculateEqualMergeCells(fixedRowsMergedCellsMap, mergeFixedRowsEqualCellsOption)
      const obj = transformMergeCellsToRowColSpanResult(mergeCells)
      if (!obj) {
        return
      }
      const { mergedColRowSpanResult = {} } = obj
      this.states.fixedRowsMergedCellsMap = mergedColRowSpanResult
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/store/modules/fixed-rows.js